var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM15.26 7.96L12.95 10.94C12.66 11.31 12.25 11.55 11.78 11.6C11.31 11.66 10.85 11.53 10.48 11.24L8.65 9.8C8.58 9.74 8.5 9.74 8.46 9.75C8.42 9.75 8.35 9.77 8.29 9.85L5.91 12.94C5.76 13.13 5.54 13.23 5.32 13.23C5.16 13.23 5 13.18 4.86 13.07C4.53 12.82 4.47 12.35 4.72 12.02L7.1 8.93C7.39 8.56 7.8 8.32 8.27 8.26C8.73 8.2 9.2 8.33 9.57 8.62L11.4 10.06C11.47 10.12 11.54 10.12 11.59 10.11C11.63 10.11 11.7 10.09 11.76 10.01L14.07 7.03C14.32 6.7 14.8 6.64 15.12 6.9C15.45 7.17 15.51 7.64 15.26 7.96Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.a170872b29119abc0eb795a040317d03.svg";
export { ForwardRef as ReactComponent };